import React, { FC, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Spin } from 'antd';
import { HttpService } from '@core/services';
import { ProjectManagementHttpService } from '@core/services/http';
import { getProjectBundleIDParamFromUrl } from '@core/utils/methods';
import { Financial } from '@shared/components/financial';
import { ProjectManagementActions } from '@store/actions';
import { ProjectManagementSelectors } from '@store/selectors';

import './styles.scss';

export const PMFinancialTab: FC = () => {
  const dispatch = useDispatch();
  const [projectBundleID] = getProjectBundleIDParamFromUrl();

  const isLoading = useSelector(
    ProjectManagementSelectors.getTabLoadingState('financial'),
  );
  const isDataLoaded = useSelector(
    ProjectManagementSelectors.getTabLoadedState('financial'),
  );

  useEffect(() => {
    const fetchData = async (): Promise<void> => {
      if (!isDataLoaded) {
        dispatch(
          ProjectManagementActions.setTabLoading.done({
            tabName: 'financial',
            isLoading: true,
          }),
        );

        await HttpService.getHttpRequests(
          ProjectManagementHttpService,
        ).getProjectManagementFinancial(projectBundleID);
      }
    };

    fetchData();
  }, [dispatch, isDataLoaded]);

  if (isLoading || !isDataLoaded) {
    return (
      <div className="prov-pm-financial__loading">
        <Spin size="large" />
      </div>
    );
  }

  return (
    <Financial
      feeAccessPath="projectManagement"
      siteDataRootPath={['site']}
      projectTypeSelector={ProjectManagementSelectors.getProjectType}
      projectIdSelector={ProjectManagementSelectors.getProjectId}
    />
  );
};
